const HealthCheck = () => {
  return 'healthy';
};
export default HealthCheck;